module.exports = __webpack_public_path__ + "img/bg_breeds_cat.60d20f68.png";